import { useScrollAnimation } from "@/hooks/useScrollAnimation";

export default function PrivacyPage() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <div className="min-h-screen bg-background-50">
      {/* Page Header */}
      <section className="relative py-20 md:py-28 px-4 lg:px-8 bg-background-100 rounded-3xl mx-4 lg:mx-8 mt-4 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20dark%20charcoal%20background%20with%20subtle%20golden%20line%20patterns%2C%20elegant%20legal%20document%20aesthetic%2C%20warm%20gold%20accents%20on%20deep%20black%2C%20sophisticated%20minimal%20corporate%20style%2C%20soft%20gradients%2C%20no%20text&width=1600&height=500&seq=privacy-header-001&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/15" />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center px-3 py-1.5 rounded-md bg-primary-100 mb-6">
            <span className="text-primary-700 text-xs font-bold uppercase tracking-wider">
              法務情報
            </span>
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
            プライバシーポリシー
          </h1>
          <p className="text-foreground-600 text-base max-w-2xl mx-auto">
            最終更新日: 2026年6月1日
          </p>
        </div>
      </section>

      {/* Content */}
      <section
        ref={ref}
        className={`py-16 md:py-20 px-4 lg:px-8 animate-on-scroll ${
          isVisible ? "is-visible" : ""
        }`}
      >
        <div className="max-w-4xl mx-auto">
          <article className="prose prose-lg max-w-none">
            <div className="space-y-10">
              {/* Section 1 */}
              <div>
                <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                  1. はじめに
                </h2>
                <p className="text-foreground-600 text-base leading-relaxed">
                  株式会社銀行データカード（以下「当社」）は、お客様の個人情報の保護を最重要事項と位置づけ、
                  個人情報保護法（個人情報の保護に関する法律）および関連法令を遵守し、
                  以下のプライバシーポリシーに従ってお客様の個人情報を適切に取り扱います。
                </p>
              </div>

              {/* Section 2 */}
              <div>
                <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                  2. 収集する個人情報
                </h2>
                <p className="text-foreground-600 text-base leading-relaxed mb-3">
                  当社は、以下の情報を収集することがあります：
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li className="text-foreground-600 text-base">
                    お名前、会社名、役職などの基本情報
                  </li>
                  <li className="text-foreground-600 text-base">
                    メールアドレス、電話番号などの連絡先情報
                  </li>
                  <li className="text-foreground-600 text-base">
                    当社サービスのご利用履歴や取引データ
                  </li>
                  <li className="text-foreground-600 text-base">
                    Cookie やアクセスログなどの技術的情報
                  </li>
                  <li className="text-foreground-600 text-base">
                    お問い合わせ内容やご要望に関する情報
                  </li>
                </ul>
              </div>

              {/* Section 3 */}
              <div>
                <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                  3. 個人情報の利用目的
                </h2>
                <p className="text-foreground-600 text-base leading-relaxed mb-3">
                  当社は、収集した個人情報を以下の目的で利用します：
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li className="text-foreground-600 text-base">
                    金融データ処理サービスおよび関連ソリューションの提供
                  </li>
                  <li className="text-foreground-600 text-base">
                    お客様からのお問い合わせ・ご依頼への対応
                  </li>
                  <li className="text-foreground-600 text-base">
                    サービス改善のための分析および研究開発
                  </li>
                  <li className="text-foreground-600 text-base">
                    新サービスや重要な更新情報のご案内
                  </li>
                  <li className="text-foreground-600 text-base">
                    法令に基づく義務の履行およびセキュリティ対策
                  </li>
                </ul>
              </div>

              {/* Section 4 */}
              <div>
                <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                  4. 個人情報の管理と保護
                </h2>
                <p className="text-foreground-600 text-base leading-relaxed">
                  当社は、お客様の個人情報を不正アクセス、紛失、漏洩、改ざんなどから保護するため、
                  AES-256暗号化技術、ファイアウォール、アクセス制御などの厳格なセキュリティ対策を実施しています。
                  また、従業員に対する定期的なセキュリティ教育を実施し、
                  個人情報の適切な管理を徹底しています。
                </p>
              </div>

              {/* Section 5 */}
              <div>
                <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                  5. 第三者提供
                </h2>
                <p className="text-foreground-600 text-base leading-relaxed">
                  当社は、法令に基づく場合またはお客様の事前同意がある場合を除き、
                  お客様の個人情報を第三者に提供することはありません。
                  ただし、業務委託先に対しては、必要な範囲内で個人情報を提供することがあります。
                  その場合、委託先に対して適切な監督を行います。
                </p>
              </div>

              {/* Section 6 */}
              <div>
                <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                  6. クッキー（Cookie）の使用
                </h2>
                <p className="text-foreground-600 text-base leading-relaxed">
                  当社のウェブサイトでは、ユーザー体験の向上およびアクセス解析のために
                  Cookie を使用しています。Cookie の使用に関する詳細は、
                  <a href="/cookies" className="text-primary-500 font-medium hover:text-primary-600 transition-colors">
                    Cookie 政策
                  </a>
                  をご参照ください。
                </p>
              </div>

              {/* Section 7 */}
              <div>
                <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                  7. お客様の権利
                </h2>
                <p className="text-foreground-600 text-base leading-relaxed">
                  お客様は、ご自身の個人情報の開示、訂正、削除、利用停止を当社に請求することができます。
                  これらの請求については、下記のお問い合わせ先までご連絡ください。
                  法令に基づき、合理的な期間内に対応いたします。
                </p>
              </div>

              {/* Section 8 */}
              <div>
                <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                  8. 本ポリシーの改定
                </h2>
                <p className="text-foreground-600 text-base leading-relaxed">
                  当社は、法令の変更や事業上の必要に応じて、本ポリシーを改定することがあります。
                  重要な変更がある場合は、当社ウェブサイト上で告知いたします。
                </p>
              </div>

              {/* Section 9 */}
              <div>
                <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                  9. お問い合わせ
                </h2>
                <p className="text-foreground-600 text-base leading-relaxed">
                  本ポリシーに関するご質問やご意見がございましたら、以下の連絡先までお気軽にお問い合わせください。
                </p>
                <div className="mt-4 p-5 rounded-xl bg-background-100">
                  <p className="text-foreground-950 font-medium text-sm">
                    株式会社銀行データカード
                  </p>
                  <p className="text-foreground-600 text-sm mt-1">
                    個人情報保護管理者 宛
                  </p>
                  <p className="text-foreground-600 text-sm mt-1">
                    メール: admin@bankcheckdata-card.jp
                  </p>
                </div>
              </div>
            </div>
          </article>
        </div>
      </section>
    </div>
  );
}